exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".TicketCard-default-2Ivtl p{margin:0}.TicketCard-purpose-r4sFp h5{overflow:hidden;height:36px;line-height:36px;white-space:nowrap;text-overflow:ellipsis}.TicketCard-status-28lMD{overflow:hidden}.TicketCard-status-28lMD i{display:block;float:right}.TicketCard-status-28lMD h5{display:none;overflow:hidden;height:36px;line-height:36px}.TicketCard-status-28lMD h5 small{display:inline-block}.TicketCard-status-28lMD h5 small:first-letter{text-transform:uppercase}@media (min-width:768px){.TicketCard-status-28lMD h5{display:initial}}.TicketCard-caller-2QWcl{padding:10px 12px;border-top:1px solid #d6dde1;background:#fbfbfb}@media (min-width:768px){.TicketCard-caller-2QWcl{margin-bottom:-500px;padding-bottom:500px}}.TicketCard-assignee-2zm6j{padding:10px 12px}.TicketCard-assignee-2zm6j,.TicketCard-state-3jepk{border-top:1px solid #d6dde1}.TicketCard-stateContent-2mKiR{margin:10px 0;padding:0 12px}@media (min-width:768px){.TicketCard-stateContent-2mKiR{margin-bottom:-500px;padding-bottom:500px;border-left:1px dotted #d6dde1}}.TicketCard-capitalize-1mJBs{display:inline-block}.TicketCard-capitalize-1mJBs:first-letter{text-transform:uppercase}", ""]);

// exports
exports.locals = {
	"default": "TicketCard-default-2Ivtl",
	"purpose": "TicketCard-purpose-r4sFp",
	"status": "TicketCard-status-28lMD",
	"caller": "TicketCard-caller-2QWcl",
	"assignee": "TicketCard-assignee-2zm6j",
	"state": "TicketCard-state-3jepk",
	"stateContent": "TicketCard-stateContent-2mKiR",
	"capitalize": "TicketCard-capitalize-1mJBs"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?localIdentName=[name]-[local]-[hash:base64:5]!./~/autoprefixer-loader!./~/less-loader!./lib/ticket/components/TicketCard.less
// module id = 1775
// module chunks = 0